import { render, staticRenderFns } from "./subcategories.vue?vue&type=template&id=d5ec02c0&scoped=true&"
import script from "./subcategories.vue?vue&type=script&lang=js&"
export * from "./subcategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ec02c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5ec02c0')) {
      api.createRecord('d5ec02c0', component.options)
    } else {
      api.reload('d5ec02c0', component.options)
    }
    module.hot.accept("./subcategories.vue?vue&type=template&id=d5ec02c0&scoped=true&", function () {
      api.rerender('d5ec02c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tickets/categories/partials/subcategories.vue"
export default component.exports